module.exports = __webpack_public_path__ + "img/ia-03-4.7767883e.jpg";